import * as React from 'react';
import { GeneralSettingsController } from './controller/GeneralSettingsController';
import { Dialog } from 'components/dialog';
import { TextField } from 'components/input/TextField';
import { SimpleSelect, SelectItem } from 'components/input/SimpleSelect';
import { Button } from '@material-ui/core';
import { DatePicker } from 'components/input/DatePicker';

export class AddExtraWorkDayDialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {
            desc: "",
            selectedDate: new Date(),
            type: "holiday"
        }

        this.handleCancelClicked = this.handleCancelClicked.bind(this);
        this.handleSaveClicked = this.handleSaveClicked.bind(this);

        this.onDateChange = this.onDateChange.bind(this);
        this.onDescChange = this.onDescChange.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
    }

    private handleCancelClicked() {
        this.props.onClose();
    }

    private async handleSaveClicked() {
        try {
            var d = this.state.selectedDate;
            await this.props.controller.onAddExtraWorkDay("" + d.toISOString(), this.state.desc, this.state.type == 'holiday');
        } catch (ex) {
            this.setState({error: ex.toString()})
        }
    }

    private onDateChange(newDate: Date) {
        this.setState({selectedDate: newDate});
    }

    private onDescChange(newDesc: string) {
        this.setState({desc: newDesc});
    }

    private onTypeChange(newType: string) {
        this.setState({type: newType});
    }

    public render() {
        return (
            <Dialog title="Add extra work day / holiday" error={this.state.error}>

                <DatePicker label="Date" value={this.state.selectedDate} onChange={this.onDateChange} />

                <TextField label="Description" value={this.state.desc} onChange={this.onDescChange}></TextField>

                <SimpleSelect label="Type" defaultValue={this.state.type} onChange={this.onTypeChange}>
                    <SelectItem title="Holiday" value="holiday"></SelectItem>
                    <SelectItem title="Extra work day" value="extraworkday"></SelectItem>
                </SimpleSelect>

                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <Button color="secondary" onClick={this.handleCancelClicked}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.handleSaveClicked}>Save</Button>
                </div>

            </Dialog>
        );
    }

}

export interface Props {

    controller: GeneralSettingsController;
    onClose: { (): void }

}

interface State {

    selectedDate: Date;
    desc: string;
    type: string;
    error?: string;

}